const axios = require('axios')
const qs = require('qs')
const Header = require('./auth')
const {
  ORDER_BUSSINESS_TABLE_LIST_URL,
  ORDER_BUSSINESS_STATUS_CHANGE_URL,
  GET_SHOPID_NAME_LIST_URL,
  GET_TABLE_LIST_URL,
  ADDRESS_LIST_URL,
  ADDRESS_ID_LIST_URL
} = require('./url')

/* 根据id获得用户的地址信息 */
// function getAddressList ({ pages, limit }) {
//     Header.axiosStop()
//     return new Promise((resolve, reject) => {
//     axios.get(ADDRESS_LIST_URL, qs.stringify({
//         pages: 1,
//         limit: 6
//     }))
//         .then(res => {
//         resolve(res)
//     })
//     .catch(err => {
//         reject(err)
//     })
// })
// }
function getAddressList (data) {
    Header.axiosStop()
    return new Promise((resolve, reject) => {
    axios.get(`${ADDRESS_LIST_URL}?pages=${data.pages}&limit=${data.limit}`)
        .then(res => {
        resolve(res)
        })
        .catch(err => {
        reject(err)
        })
    })
}

// function getAddressListById (id) {
//     Header.axiosStop()
//     return new Promise((resolve, reject) => {
//         axios.get(`${ADDRESS_ID_LIST_URL}/${sendData.id})
//         .then(res => {
//             resolve(res)
//             })
//             .catch(err => {
//             reject(err)
//             })
//     })
// }

function getAddressListById (id) {
    return new Promise((resolve, reject) => {
    Header.axiosStop()
    axios.get(ADDRESS_ID_LIST_URL, qs.stringify(
        {
            id: id
    }
    ))
        .then(function (response) {
        resolve(response)
        })
        .catch(function (error) {
        reject(error)
        })
    })
}

/* 根据用户名获取店铺名 */
function getShopNameList ({ pageNum, pageSize, userName }) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.get(`${GET_SHOPID_NAME_LIST_URL}/${userName}/${pageNum}/${pageSize}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 根据店铺id获取表格数据 */
function getTableList (shopId) {
// console.log(shopId)
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.get(`${GET_TABLE_LIST_URL}/${shopId}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// function getBussinessTableList({
//   current,
//   shopId,
//   size,
//   status
// }) {
//   Header.axiosStop()
//   return new Promise((resolve, reject) => {
//     axios.get(`${ORDER_BUSSINESS_TABLE_LIST_URL}/${current}/${shopId}/${size}/${status}`)
//       .then(res => {
//         // console.log(res)
//         resolve(res)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

function getBussinessTableList ({ current, shopId, size, status }) {
  return new Promise((resolve, reject) => {
    Header.axiosStop()
    axios
      .get(ORDER_BUSSINESS_TABLE_LIST_URL, {
        params: {
          current: current,
          shopId: shopId,
          size: size,
          status: status
        }
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        console.log(error)
        reject(error)
      })
  })
}
/* 商户根据商品id，地址表的地址id和用户id修改订单状态 */
// function changeBussinessOrderStatus (sendData) {
//   return new Promise((resolve, reject) => {
//     axios.put(`${ORDER_BUSSINESS_STATUS_CHANGE_URL}/${sendData.orderId}/${sendData.shippingId}/${sendData.userId}`)
//       .then(res => {
//         // console.log(res)
//         resolve(res)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }
/* 改变订单状态为待收货状态 */
// )
function changeBussinessOrderStatus (sendData) {
    // console.log('xixi')
    // console.log(orderId, shippingId, userId)
  return new Promise((resolve, reject) => {
    Header.axiosStop()
    axios.put(ORDER_BUSSINESS_STATUS_CHANGE_URL, qs.stringify(
        {
            orderId: sendData.orderId,
            shippingId: sendData.shippingId,
            userId: 5
    }
    ))
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

module.exports = {
  getShopNameList,
  getTableList,
  getBussinessTableList,
  changeBussinessOrderStatus,
  getAddressList,
  getAddressListById
//   changeOrderStatus
}
